/* eslint-disable */
import moment from 'moment';
import map from 'lodash/map';
import mapValues from 'lodash/mapValues';
import compact from 'lodash/compact';

import { INTERVAL, PROVIDER_OPTION, PROVIDERS } from '../constants';
import { convertCelsiusToFahrenheit } from '../../../PatientHealthboard/utils';
import { COLORS } from '../../../../constants/styles';
import { PERIOD } from '../constants/period';

// LABELS

const getLabel = (date, unit) => {
  if (!unit) return moment(date).toISOString();

  return moment(date)
    .startOf(unit)
    .toISOString();
};

const getLabels = (head, tail, unit) => {
  const diff = moment(tail).diff(head, unit) + 1;

  if (!unit) return new Map().set(head, []).set(tail, []);

  const res = [...Array(diff)].reduce(
    (labels, _, idx) =>
      labels.set(
        moment(head)
          .add(idx, unit)
          .toISOString(),
        [],
      ),
    new Map(),
  );

  return res;
};

// DATA
const { OPTIONS, RESOURCES } = PROVIDER_OPTION;

export const mapChartData = (data, customOptions) => {
  const {
    unit,
    date,
    range,
    period,
    providers,
    shouldConvertToFahrenheit,
  } = customOptions;

  const { head, tail } = INTERVAL[period](date);

  let labels = getLabels(head, tail, unit);

  let sources = data.reduce(
    (results, { provider, measurements }) =>
      Object.values(PROVIDERS).includes(provider.code)
        ? {
            ...results,
            [provider.code]: measurements.reduce(
              (indicators, { value: values, measuredAt }) => {
                const label = getLabel(measuredAt, unit);

                if (!unit) labels.set(label, []);

                Object.entries(values).forEach(([name, value]) => {
                  const indicator = indicators[name] || new Map();

                  indicators[name] = indicator.set(label, [
                    ...(indicator.get(label) || []),
                    value,
                  ]);
                });

                return indicators;
              },
              {},
            ),
          }
        : results,
    {},
  );

  labels = new Map(
    [...labels].sort(([prev], [next]) => moment(prev) - moment(next)),
  );

  sources = mapValues(sources, source =>
    mapValues(source, values => new Map([...labels, ...values])),
  );

  const datasets = map(sources, (values, providerCode) =>
    map(values, (vals, resourceName) => {
      const data = shouldConvertToFahrenheit
        ? [...vals.values()]
            .map(v => (range ? range(v) || null : v))
            .map(v => (v ? convertCelsiusToFahrenheit(v) : v))
        : [...vals.values()].map(v => (range ? range(v) || null : v));
      return {
        ...providers[providerCode][RESOURCES][resourceName][OPTIONS][period],
        label: `${providerCode}.${resourceName}`,
        data,
        ...(compact(data).length === 1 &&
          [PERIOD.QUARTER, PERIOD.YEAR].includes(period) && {
            pointRadius: 3.5,
            pointHoverRadius: 3.5,
            hoverBackgroundColor: COLORS.orangeRed,
            hoverBorderColor: COLORS.orangeRed,
            hoverBorderWidth: 1.5,
            hoverBorderRadius: 0,
          }),
      };
    }),
  ).flat();

  return { customOptions, datasets, labels: [...labels.keys()] };
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/helpers/mapChartData.js